export default __webpack_public_path__ + "static/media/1bg_p.4a7e835f.jpg";